import React, { useEffect, useState, useMemo } from "react";
import PageHero from "../components/PageHero";
import { api } from "../lib/api";
import { Trophy, Medal, Award, Star } from "lucide-react";
import { Badge } from "../components/ui/badge";

export default function Achievements() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("Semua");
  const [level, setLevel] = useState("Semua");

  useEffect(() => { api.get("/achievements?limit=200").then(({ data }) => setItems(data.items)).catch(() => {}); }, []);

  const categories = useMemo(() => ["Semua", ...Array.from(new Set(items.map((i) => i.category)))], [items]);
  const levels = useMemo(() => ["Semua", "Kabupaten", "Provinsi", "Nasional", "Internasional"], []);
  const filtered = items.filter((i) => (cat === "Semua" || i.category === cat) && (level === "Semua" || i.level === level));

  const stats = {
    total: items.length,
    akademik: items.filter((i) => i.category === "Akademik").length,
    olahraga: items.filter((i) => i.category === "Olahraga").length,
    seni: items.filter((i) => i.category === "Seni").length,
  };

  return (
    <div data-testid="achievements-page">
      <PageHero
        eyebrow="Prestasi"
        title="Hall of Fame"
        subtitle="Kebanggaan SMAS YPK 2 Biak — prestasi murid di berbagai bidang: akademik, olahraga, seni, sains, dan kepemimpinan."
        image="https://images.unsplash.com/photo-1580692475446-c2fabbbbf835?w=2000&q=80"
      />

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-5">
          {[
            { label: "Total Prestasi", value: stats.total, icon: Trophy },
            { label: "Akademik", value: stats.akademik, icon: Star },
            { label: "Olahraga", value: stats.olahraga, icon: Medal },
            { label: "Seni", value: stats.seni, icon: Award },
          ].map((s) => {
            const I = s.icon;
            return (
              <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`} className="card-elevated p-6">
                <I className="w-7 h-7 text-amber-500" />
                <div className="mt-4 font-serif text-4xl font-black text-[#0B1D3A]">{s.value}</div>
                <div className="text-xs uppercase tracking-wider text-slate-500 mt-1">{s.label}</div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap gap-5 mb-10">
            <div>
              <div className="text-xs font-semibold text-slate-500 mb-2 uppercase tracking-wider">Kategori</div>
              <div className="flex flex-wrap gap-2">
                {categories.map((c) => (
                  <button key={c} data-testid={`filter-cat-${c.toLowerCase()}`} onClick={() => setCat(c)}
                    className={`px-3.5 py-1.5 rounded-full text-sm font-semibold ${cat === c ? "bg-[#0B1D3A] text-white" : "bg-white text-slate-700 border border-slate-200 hover:border-amber-400"}`}>{c}</button>
                ))}
              </div>
            </div>
            <div>
              <div className="text-xs font-semibold text-slate-500 mb-2 uppercase tracking-wider">Tingkat</div>
              <div className="flex flex-wrap gap-2">
                {levels.map((l) => (
                  <button key={l} data-testid={`filter-level-${l.toLowerCase()}`} onClick={() => setLevel(l)}
                    className={`px-3.5 py-1.5 rounded-full text-sm font-semibold ${level === l ? "bg-amber-500 text-[#0B1D3A]" : "bg-white text-slate-700 border border-slate-200 hover:border-amber-400"}`}>{l}</button>
                ))}
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((a) => (
              <div key={a.id} data-testid={`achievement-${a.id}`} className="card-elevated p-6">
                <div className="flex items-start justify-between">
                  <Trophy className="w-9 h-9 text-amber-500" />
                  <Badge className="bg-amber-50 text-amber-700 border-amber-200 text-[11px] font-semibold">{a.level}</Badge>
                </div>
                <div className="font-serif text-lg font-bold text-[#0B1D3A] mt-4 leading-tight">{a.name}</div>
                <div className="text-sm text-slate-600 mt-2">{a.student_name}</div>
                <div className="mt-4 pt-4 border-t border-slate-100 flex items-center justify-between text-xs">
                  <span className="text-amber-600 font-semibold">{a.category}</span>
                  <span className="text-slate-400">{a.year}</span>
                </div>
              </div>
            ))}
          </div>
          {filtered.length === 0 && (
            <div className="text-center py-16 text-slate-500">Tidak ada prestasi untuk filter yang dipilih.</div>
          )}
        </div>
      </section>
    </div>
  );
}
